import { checkIfShowingTips } from "~src/tips/index.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
let phones = [];
export let tipsInterval = null;
export let stopPhones = {};
let hl;


export const checkTipGlow = (scene) => {



  var material1 = new BABYLON.StandardMaterial("mat1", scene);
  material1.alpha = 0
  material1.diffuseColor = new BABYLON.Color3(0, 0, 0);

  if (!hl) hl = new BABYLON.HighlightLayer("hl", scene);
      hl.blurHorizontalSize = 0.6;
      hl.blurVerticalSize = 0.6;
  if (tipsInterval) clearInterval(tipsInterval);


  let flatGlowing = false;
  let bunkerGlowing = false;
  let warehouseGlowing = false;

  const createSounds = () => {
    const phone1Sound = scene.getSoundByName("soundP1")
    const phone2Sound = scene.getSoundByName("soundP2")
    const phone3Sound = scene.getSoundByName("soundP3")

    return { phone1Sound, phone2Sound, phone3Sound };
  };

  const { phone1Sound, phone2Sound, phone3Sound } = createSounds();

  stopPhones.stop = mobileOrNot()
    ? () => null
    : () => {
      if(phone1Sound?.isPlaying) {
        phone1Sound.stop();
      }
      if(phone2Sound?.isPlaying) {
        phone2Sound.stop();
      }  
      if(phone3Sound?.isPlaying) {
        phone3Sound.stop();
      }

      };

  if (mobileOrNot()) {
    phones.push(phone1Sound, phone2Sound, phone3Sound);
  }
   tipsInterval = window.setInterval(() => {
    const flatPuhelin = scene.getMeshByName("H1_Vihje_glow");
    const warehousePuhelin = scene.getMeshByName("H2_Vihje_glow");
    const bunkerPuhelin = scene.getMeshByName("H3_Vihje_glow");

    // add transparent materials
    flatPuhelin.material = material1;
    warehousePuhelin.material = material1;
    bunkerPuhelin.material = material1;

    if (warehousePuhelin) warehousePuhelin.visibility = 1;
    const showingTips = checkIfShowingTips();
    const flatTipsShowing =
      showingTips && showingTips.filter((e) => e.room === "flat" && !e.opened)
      
    const warehouseTipsShowing =
      showingTips &&
      showingTips.filter((e) => e.room === "warehouse" && !e.opened);
    const bunkerTipsShowing =
      showingTips &&
      showingTips.filter((e) => e.room === "bunker" && !e.opened);
    if (showingTips) {
      // Tämä ajetaan, jos on vinkkejä

      if (flatPuhelin && !flatGlowing && flatTipsShowing.length > 0) {
        hl.addMesh(flatPuhelin, BABYLON.Color3.Green());
        
        flatGlowing = true;
        console.log("phone1 ringing");
        if (typeof phone1Sound !== "undefined") {
          phone1Sound.play();
        }
      }
      if (bunkerPuhelin && !bunkerGlowing && bunkerTipsShowing.length > 0) {
        bunkerPuhelin
          ? hl.addMesh(bunkerPuhelin, BABYLON.Color3.Green())
          : null;
        bunkerGlowing = true;
        console.log("phone2 ringing");
        if (typeof phone3Sound !== "undefined") {
          phone3Sound.play();
        }
      }
      if (
        warehousePuhelin &&
        !warehouseGlowing &&
        warehouseTipsShowing.length > 0
      ) {
        warehousePuhelin
          ? hl.addMesh(warehousePuhelin, BABYLON.Color3.Green())
          : null;
        warehouseGlowing = true;
        console.log("phone3 ringing");
        if (typeof phone2Sound !== "undefined") {
          phone2Sound.play();
        }
      }
    } else {
       document.querySelector(".puhelin-ikoni").style.display = "none";
      // Tämä ajetaan, jos ei ole vinkkejä
      if (flatGlowing) {
        hl.removeMesh(flatPuhelin);
        flatGlowing = false;
        if (typeof phone1Sound !== "undefined") {
          phone1Sound.stop();
        }
      }
      if (bunkerGlowing) {
        hl.removeMesh(bunkerPuhelin);
        bunkerGlowing = false;
        if (typeof phone3Sound !== "undefined") {
          phone3Sound.stop();
        }
      }
      if (warehouseGlowing) {
        hl.removeMesh(warehousePuhelin);
        warehouseGlowing = false;
        if (typeof phone2Sound !== "undefined") {
          phone2Sound.stop();
        }
      }
    }
  }, 1000);
};
